import * as React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { sortBy } from "lodash";
import type { ClientFlow, DeploymentMode } from "./types";
import type { selectedYear } from "../../store/features/envSlice";

export interface RecapPopUpProps {
  enabled: boolean;
  clients: ClientFlow[];
  clientYears: selectedYear[];
  deployment: string;               // Environnement (ex: development)
  deploymentMode: DeploymentMode; // "", Light, Heavy, Deployment
  runPhase: string;
  handleSendFlowRun: () => void;
}

export const RecapButton: React.FC<RecapPopUpProps> = ({
  enabled,
  clients,
  clientYears,
  deployment,
  deploymentMode,
  runPhase,
  handleSendFlowRun,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleAgreeButton = () => {
    handleSendFlowRun();
    setOpen(false);
  };

  const getClientName = (sy: selectedYear) => clients.find((c) => c.id === sy.id)?.name;
  const clientYearsTextRows = sortBy(clientYears, ["id", "year"]).map((c) => `${getClientName(c)} - ${c.year}`);

  const textRows = [
    `Environnement: ${deployment}`,
    ...(deploymentMode ? [`Deployment: ${deploymentMode}`] : []),
    `Run Phase: ${runPhase}`,
    ...clientYearsTextRows,
  ];

  return (
    <>
      <Button variant="contained" disabled={!enabled} onClick={handleClickOpen}>
        Recap
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Flow runs recap</DialogTitle>
        <DialogContent>
          {textRows.map((text) => (
            <DialogContentText key={text}>{text}</DialogContentText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={handleAgreeButton} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
